
import { defineComponent, ref, watch, onMounted, Ref, computed } from "vue";
import useEmitter from "@/composables/Emmiter";
import { useRoute } from "vue-router";

import FilterBase from "@/layout/header/partials/filters/FilterBase.vue";
import Api from "@/services/Api";
import { ElConfigProvider } from "element-plus";
import ptBr from "element-plus/lib/locale/lang/pt-br";

interface AttendanceFilter {
  placa: string;
  veiculo: string;
  responsavel: string;
  data: any;
  status: string;
  idAtendimento: string,
  codConcessionariaTeste: any[]
}

export default defineComponent({
  name: "FilterAttendance",
  components: {
    FilterBase,
    ElConfigProvider,
  },

  setup(props, { emit }) {
    const emitter = useEmitter();
    const route = useRoute();
    const closeModal = ref(false);
    const lojas: Ref<any[]> = ref([]);
    const statusAttendance: string[] = ["Aberto", "Enviado", "Fechado", "Vendido", "Cancelado", "Andamento", "Precificar", "Pendente Aprovação", "Pago"];
    const selectedConcessionarias: Ref<any> = ref([]);
    const storeId = computed(() => route.query.storeId)


    const attendanceFilter: Ref<AttendanceFilter> = ref({
      placa: "",
      veiculo: "",
      responsavel: "",
      data: "",
      status: "",
      idAtendimento: "",
      codConcessionariaTeste: []
    });

    async function getLojas() {
     if(!storeId.value) {
        const res = await Api.get("getAllStores");
        lojas.value = res.data.lojas;
      }
    }

    function enviarEmit() {
      emitter.emit("Filter-Atendimentos", attendanceFilter.value );
      closeModal.value = !closeModal.value;
    }

    function preencheFiltro(){

      //'placa', 'veiculo', 'responsavel', 'status', 'idAtendimento', 'codConcessionaria'
      const { placa, veiculo, responsavel, data, status, idAtendimento, codConcessionaria } = route.query as any;


      attendanceFilter.value.placa = placa as any
      attendanceFilter.value.veiculo = veiculo as any
      attendanceFilter.value.responsavel = responsavel as any
      attendanceFilter.value.data = data as any
      attendanceFilter.value.status = status as any
      attendanceFilter.value.idAtendimento = idAtendimento as any
      const idsLojas = codConcessionaria ? codConcessionaria.split(',') : []
      //console.log(idsLojas)
      let resultado = [] as any

      lojas.value.forEach(e => {
        
        const exists = idsLojas.some(i => i == e.codConcessionaria)
        
        if(!exists) return

        resultado.push(e.codConcessionaria)
        
      })
      attendanceFilter.value.codConcessionariaTeste = resultado
      
    }

    onMounted(() => {
      getLojas()
      preencheFiltro()
    });

    return {
       attendanceFilter,
        lojas,
        enviarEmit,
        closeModal,
        ElConfigProvider,
        ptBr,
        statusAttendance,
        selectedConcessionarias,
        storeId,
        preencheFiltro
      };
  },
});
